export enum CreateMessageTypes {
    NEW = 'new',
    COMPOSE = 'compose',
    REPLY = 'reply',
};
  